import type { RootState } from 'src/redux/store';
import { APP_NAME } from '../settings/organizationSettings';

// Priority pricing exists only for the DFW marketplace org, and only until Pricing V2 replaces it.
export const selectIsPriorityPricingEnabled = (state: RootState): boolean =>
  state.StartAppSettings?.organization?.internal_code === APP_NAME.dayforce_flex_work &&
  !state.StartAppSettings?.feature_flags?.pricing_configuration_enabled;
